<template>
  <v-layout>
    <v-flex class="pa-1">
      <v-text-field
        label="Name"
        v-model="variable.name"
        outline
        name="scheduletime"
        :hide-details="true"
        @blur="onBlur"
      ></v-text-field>
    </v-flex>
    <v-flex class="pa-1">
      <v-text-field
        label="Value"
        v-model="variable.value"
        outline
        name="scheduletime"
        :hide-details="true"
        @blur="onBlur"
      ></v-text-field>
    </v-flex>
    <v-flex shrink>
      <v-btn fab small flat @click="$emit('deleteVariable')"><v-icon>close</v-icon></v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      variable: {
        name: '',
        value: ''
      }
    }
  },
  mounted() {
    this.variable = this.setVariable(this.value)
  },
  methods: {
    setVariable(value) {
      try {
        var variable = value.split('=')

        if (variable.length == 2) {
          // console.log(variable)
          return {
            name: variable[0],
            value: variable[1]
          }
        }
      } catch (error) {
        console.log(error)
      }

      return {
        name: '',
        value: ''
      }
    },
    onBlur() {
      this.$emit('input', `${this.variable.name}=${this.variable.value}`)
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) this.variable = this.setVariable(newVal)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/BroadcastVariable.vue